import React from 'react';

import styles from '../../styles/navigation/styles.module.css';
import { Item } from '../../types/carousel';

export const Navigation: React.FC<NavigationProps> = ({ items, current, onClick, factory }) => {
  return (
    <div className={styles.carouselNavigation}>
      {items.map((_: any, i: number) => (
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onMouseOver={() => onClick(i)}
          onFocus={() => {}}
          key={i}
        >
          {factory(current === i)}
        </div>
      ))}
    </div>
  );
};

export interface NavigationProps {
  items: Item[];
  current: number;
  factory: (selected: boolean) => React.ReactElement;
  onClick: (i: number) => void;
}
